module.exports = __webpack_public_path__ + "img/46ne.226ee575.svg";